import React from 'react';
import eventsData from '../../data/eventsData.js';

const Events = () => {
  return (
    <section id="events" className="events">
      <div className="container">
        <h2 className="section-title">Events We Cover</h2>
        <div className="events-grid">
          {eventsData.map((event) => (
            <div key={event.id} className="event-card">
              <div className="event-image">
                <img src={event.image} alt={event.name} />
              </div>
              <div className="event-content">
                <h3>{event.name}</h3>
                <p>{event.description}</p>
                <div className="event-duration">
                  <span className="duration-label">Duration:</span>
                  <span className="duration-value">{event.duration}</span>
                </div>
                <a href="#contact" className="btn btn-outline">Book Event</a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Events;
